import { render } from "./Footer2.vue?vue&type=template&id=7195c10a&scoped=true"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"

import "./Footer2.vue?vue&type=style&index=0&id=7195c10a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7195c10a"]])

export default __exports__